<template>
	<div v-bl-input>
		<input type="number" v-model="value" @input="setFilter()" />
		<span class="suffix material-icons" @click="value = null; setFilter();" style="display: block; margin-top: 10px;">{{ value ? 'remove_circle_outline' : '' }}</span>
	</div>
</template>

<script>
export default {
	name: 'BlListFilterMatchNumber',
	props: ['initialValue', 'metadata'],
	emits: ['blListFilterChange'],
	data() {
		return {
			value: null
		}
	},
	created() {
		this.value = this.initialValue
	},
	methods: {
		setFilter() {
			if(this.value) this.$emit('blListFilterChange', [[this.metadata.field.name, '=', this.value], this.value])
			else this.$emit('blListFilterChange', null)
		}
	}
}
</script>

<style scoped lang="scss">
	.suffix {
		cursor: pointer;
	}
</style>